module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/command-center-lvl2-50.ba6b799e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/command-center-lvl2-50.png
// module id = 3518
// module chunks = 11